/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_NationalityInputs */

const en_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationality`)
};

const de_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsangehoerigkeit`)
};

const fr_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationalite`)
};

const es_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nacionalidad`)
};

const it_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazionalita`)
};

const nl_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationaliteit`)
};

const pl_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narodowosc`)
};

const fi_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansalaisuus`)
};

const da_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationalitet`)
};

const sv_resume_editor_nationality = /** @type {(inputs: Resume_Editor_NationalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nationalitet`)
};

/**
* | output |
* | --- |
* | "Nationality" |
*
* @param {Resume_Editor_NationalityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_nationality = /** @type {((inputs?: Resume_Editor_NationalityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_NationalityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_nationality(inputs)
	if (locale === "fr") return fr_resume_editor_nationality(inputs)
	if (locale === "es") return es_resume_editor_nationality(inputs)
	if (locale === "it") return it_resume_editor_nationality(inputs)
	if (locale === "nl") return nl_resume_editor_nationality(inputs)
	if (locale === "pl") return pl_resume_editor_nationality(inputs)
	if (locale === "fi") return fi_resume_editor_nationality(inputs)
	if (locale === "da") return da_resume_editor_nationality(inputs)
	if (locale === "sv") return sv_resume_editor_nationality(inputs)
	return en_resume_editor_nationality(inputs)
});